export default __webpack_public_path__ + "static/AHA-7da005d0c59009c65f887726a68ed195.png";